<template>
  <el-dialog
      title="编辑房间信息"
      :visible.sync="roomDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <el-form :model="roomForm" :rules="rules" ref="roomForm" label-width="100px">
      <el-form-item label="房间名称" prop="name">
        <el-input v-model="roomForm.name" placeholder="请输入房间名称"></el-input>
      </el-form-item>
      <el-form-item label="房间状态" prop="status">
        <el-select v-model="roomForm.status" placeholder="请选择房间状态" style="width: 100%;">
          <el-option
              v-for="item in statusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('roomForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('roomForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {huUpdate} from "@/api/community";
export default {
  name: "roomDialog",
  props: {
    roomDialog: {
      type: Boolean,
      default: false
    },
    editId: {
      type: Number,
      default() {
        return 0;
      }
    },
    editName: {
      type: String,
    },
    editStatus:{
      type: Number,
    }
  },
  data() {

    return {
      statusList: [
        {value:1,label:'正常'},
        {value:2,label:'空置'},
      ],
      roomForm: {
        name: '',
        status: '',
      },
      rules: {
        name: [{required: true, message: '请输入房间名称', trigger: 'blur'}],
        status:[{required: true, message: '请选择房间状态', trigger: 'change'}]
      }
    }
  },
  computed:{
    user() {
      return this.$store.state.user
    }
  },
  methods:{
    resetForm(formName){
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog',false)
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await huUpdate(
          this.editId,
          this.roomForm.name,
          this.roomForm.status,

      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    }
  },
  watch: {
    roomDialog() {
      this.roomForm = {
        name: this.editName,
        status: this.editStatus
      };
    }
  }
}
</script>

<style scoped lang="scss">

</style>